<template>
  <div class="edit-between-number" v-if="!disabled">
    <el-input-number
      :min="min"
      :max="value[1]"
      size="mini"
      v-model="value[0]"
      @change="onChange"
      controls-position="right"
      :precision="precision"
    ></el-input-number>
    <span class="edit-between-split">~</span>
    <el-input-number
      :min="value[0]"
      :max="max"
      size="mini"
      v-model="value[1]"
      @change="onChange"
      controls-position="right"
      :precision="precision"
    ></el-input-number>
  </div>
  <span v-else-if="value[0] !== undefined || value[1] !== undefined"
    >{{ value[0] }} ~ {{ value[1] }}</span
  >
</template>
<script>
import EditMixin from "./edit-mixin";
export default {
  mixins: [EditMixin],
  props: {
    value: {
      type: Array,
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    min: {
      type: Number,
      required: false,
      default: undefined,
    },
    max: {
      type: Number,
      required: false,
      default: undefined,
    },
    precision: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    onChange() {
      if (this.value[0] !== undefined && this.value[1] !== undefined) {
        console.log();
      }
      this.$emit("change", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-between-number {
  display: flex;
  .edit-between-split {
    padding: 0 2px;
  }
  ::v-deep {
    .el-input__inner {
      padding-left: 0;
      padding-right: 32px;
    }
  }
}
</style>
